import React from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import LoadingComponent from '../components/LoadingComponent';
import { useEffect } from 'react';
import Cookies from 'js-cookie'

function RedirectLogin() {

    const [params] = useSearchParams();
    const token = params.get('token');
    const navigate = useNavigate()

    useEffect(() => {
        Cookies.set('auth', `Bearer ${token}`, {
            secure: true, sameSite: 'None',
        })
        navigate('/')
        // eslint-disable-next-line
    }, [token])

    return (
        <div className='w-full relative'>
            <LoadingComponent />
            <div className="text-center text-sm">Logging In</div>
        </div>
    )
}

export default RedirectLogin